module.exports = __webpack_public_path__ + "img/badge.c8fd9fae.png";